export default __webpack_public_path__ + "static/media/calendar.ecb95e6e.png";